import React from "react";
import { useLanguage } from "../context/LanguageContext";

export default function LanguageSwitcher({ inverted = false }) {
  const { lang, setLang } = useLanguage();

  const base =
    "relative flex items-center rounded-full p-0.5 text-[11px] font-semibold tracking-[0.15em] uppercase";
  const wrapper = inverted
    ? "bg-[#fbd9e5]/15 border border-[#fbd9e5]/30 text-[#fbd9e5]"
    : "bg-[#3e2723]/5 border border-[#3e2723]/10 text-[#3e2723]";

  const pill = (active) =>
    `px-3 py-1.5 rounded-full transition-all duration-300 ${
      active
        ? inverted
          ? "bg-[#fbd9e5] text-[#3e2723]"
          : "bg-[#3e2723] text-[#fbd9e5]"
        : "opacity-70 hover:opacity-100"
    }`;

  return (
    <div className={`${base} ${wrapper}`} data-testid="language-switcher">
      <button
        type="button"
        className={pill(lang === "ro")}
        onClick={() => setLang("ro")}
        aria-pressed={lang === "ro"}
        data-testid="lang-ro"
      >
        RO
      </button>
      <button
        type="button"
        className={pill(lang === "en")}
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
